import baseAPI from '@/http'

const router = 'api/SeloClienteOcultoGrupos'

export const seloClienteOcultoGruposAPI = {
    list: () => baseAPI.get(`${router}`),
    add: (arquivos) => baseAPI.post(`${router}`, arquivos),
    atualizar: (resposta) => baseAPI.put(`${router}`, resposta),
    delete: (evidenciaId) => baseAPI.delete(`${router}/${evidenciaId}`),

}
